import { useMemo } from "react"
import { type TMultiSelectOption } from "~/ui-rtk/components/ui/controls/MultiSelect"
import useSessionMediumOptions from "./useSessionMediumOptions"

/**
 * Provides the `getSelectOptions` resolver consumed by TableFiltersBar for the
 * landing page report's additional (non-column) filters.
 */
export function useSelectFilterOptions() {
  const { mediumOptions, isLoading } = useSessionMediumOptions()

  const getSelectOptions = useMemo(
    () =>
      (columnKey: string): TMultiSelectOption[] => {
        switch (columnKey) {
          case "session_medium":
            return mediumOptions
          default:
            return []
        }
      },
    [mediumOptions],
  )

  return {
    getSelectOptions,
    isLoading,
  }
}

export default useSelectFilterOptions
